import styled from 'styled-components';

export const IframeScormContainer = styled.div`
  position: relative;
`;

export const ButtonFullScreen = styled.button`
  position: absolute;
  display: flex;
  align-items: center;
  gap: 6px;
  right: 5px;
  bottom: 8px;
  background-color: var(--darkPurple);
  outline: none;
  border: none;
  color: white;
  padding: 2px 5px;
  border-radius: 2px;
  font-size: 1.3rem;
  cursor: pointer;
`;
